import type { ReactNode } from 'react';
import { SIGN_IN_URL } from './App.js';

/**
 * S-UI-002: Absolute-positioned overlay over skeleton rows shown when signed out.
 * The skeleton rows behind remain visible as shapes so the developer sees the page
 * structure before committing to sign-in.
 */
export function SignedOutOverlay(): ReactNode {
  return (
    <div className="signed-out-overlay" role="status" aria-label="Sign in required to browse repositories">
      <p className="signed-out-overlay__message">Sign in to browse repositories</p>
      <a
        href={SIGN_IN_URL}
        className="signed-out-overlay__signin signin-button"
        data-testid="signin-btn-overlay"
      >
        Sign in
      </a>
    </div>
  );
}
